import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const TabHeaderNew = ({
  tabList = [],
  selectedTab,
  setSelectedTab,
  classes,
  tabClasses,
  selectedColor,
}) => {
  const { t } = useTranslation();
  const handleClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <div className={`${classes}`}>
      {tabList.map((tab) => (
        <div
          key={tab.value}
          className={`d-flex justify-content-center align-items-center gap-2 cursor-pointer flex-grow-1 text-center ${tabClasses}`}
          style={
            selectedTab.value === tab.value
              ? {
                  borderBottom: '3px solid #38cb89',
                }
              : { borderBottom: '3px solid transparent' }
          }
          onClick={() => handleClick(tab)}
        >
          {tab.icon && (
            <img
              src={tab.icon}
              className='my-2'
              style={{
                width: '20px',
                height: '20px',
                objectFit: 'contain',
              }}
            />
          )}
          <span className={selectedTab.value === tab.value ? selectedColor : ''}>
            {t(tab.displayValue)}
          </span>
        </div>
      ))}
    </div>
  );
};

TabHeaderNew.propTypes = {
  tabList: PropTypes.array.isRequired,
  selectedTab: PropTypes.object,
  setSelectedTab: PropTypes.func,
  classes: PropTypes.string,
  tabClasses: PropTypes.string,
  selectedColor: PropTypes.string,
};

export default TabHeaderNew;
